import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-theme-green border-0 rounded-t-xl px-4 py-2 text-white" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "font-semibold leading-tight truncate text-single-line break-all text-2xl mt-0" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "flex justify-end items-center" }
const _hoisted_6 = { class: "pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg" }
const _hoisted_7 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-4" }
const _hoisted_8 = { class: "w-full xl:w-1/2" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "w-full xl:w-1/2" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-4" }
const _hoisted_13 = { class: "w-full xl:w-1/2" }
const _hoisted_14 = ["textContent"]
const _hoisted_15 = { class: "w-full xl:w-1/2" }
const _hoisted_16 = ["onkeypress"]
const _hoisted_17 = ["textContent"]
const _hoisted_18 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-4" }
const _hoisted_19 = { class: "w-full xl:w-1/2" }
const _hoisted_20 = { class: "bg-gray-black rounded w-full flex items-center" }
const _hoisted_21 = ["textContent"]
const _hoisted_22 = { class: "w-full xl:w-1/2" }
const _hoisted_23 = ["onkeypress"]
const _hoisted_24 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.form.first_name.value ? _ctx.form.first_name.value : 'New Customer'), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addNew()), ["prevent"])),
              class: "cursor-pointer rounded-md bg-white text-theme-green py-2 px-3 hover:bg-theme-darkgreen hover:text-white mr-3"
            }, " SAVE "),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearComponent && _ctx.clearComponent(...args)), ["prevent"])),
              class: "cursor-pointer rounded-md text-white py-2 pl-1 hover:opacity-70"
            }, "CLOSE")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.first_name.error_type))
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-xs mb-1" }, "First Name", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.first_name.value) = $event)),
              onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['first_name']))),
              placeholder: "First Name",
              class: "placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white",
              type: "text"
            }, null, 544), [
              [_vModelText, _ctx.form.first_name.value]
            ]),
            (_ctx.form.first_name.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.first_name.error_message)
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.last_name.error_type))
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-xs mb-1" }, "Last Name", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.last_name.value) = $event)),
              onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateFields(['last_name']))),
              placeholder: "Last Name",
              class: "placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white",
              type: "text"
            }, null, 544), [
              [_vModelText, _ctx.form.last_name.value]
            ]),
            (_ctx.form.last_name.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.last_name.error_message)
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.email.error_type))
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-xs mb-1" }, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email.value) = $event)),
              onKeyup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateFields(['email']))),
              placeholder: "Email",
              class: "placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white",
              type: "text"
            }, null, 544), [
              [_vModelText, _ctx.form.email.value]
            ]),
            (_ctx.form.email.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.email.error_message)
                }, null, 8, _hoisted_14))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.phone.error_type))
          }, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-xs mb-1" }, "Phone Number", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.phone.value) = $event)),
              onkeypress: _ctx.preventNonNumbers,
              onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validateFields(['phone']))),
              placeholder: "Phone Number",
              class: "placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white",
              type: "number"
            }, null, 40, _hoisted_16), [
              [
                _vModelText,
                _ctx.form.phone.value,
                void 0,
                { number: true }
              ]
            ]),
            (_ctx.form.phone.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.phone.error_message)
                }, null, 8, _hoisted_17))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.birthday.error_type))
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-xs mb-1" }, "Birthday", -1)),
            _createElementVNode("div", _hoisted_20, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "ml-2 mr-2" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "20",
                  viewBox: "0 0 18 20",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z",
                    fill: "white"
                  })
                ])
              ], -1)),
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.form.birthday.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.birthday.value) = $event)),
                placeholder: "Select a Date",
                class: "text-sm focus:border-transparent focus:ring-0 bg-gray-black border-0 w-full"
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.form.birthday.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.birthday.error_message)
                }, null, 8, _hoisted_21))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.startingPoint.error_type))
          }, [
            _cache[19] || (_cache[19] = _createElementVNode("label", { class: "text-xs mb-1" }, "Starting Point Amount", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.startingPoint.value) = $event)),
              onkeypress: _ctx.preventNonNumbers,
              onKeyup: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validateFields(['startingPoint']))),
              placeholder: "Starting Point Amount",
              class: "placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white",
              type: "number"
            }, null, 40, _hoisted_23), [
              [_vModelText, _ctx.form.startingPoint.value]
            ]),
            (_ctx.form.startingPoint.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.startingPoint.error_message)
                }, null, 8, _hoisted_24))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ])
  ]))
}